import _ from 'lodash'
import { COMPANY_PAGE_TYPE, ROOT_COMPANY_ID } from '@/constant/company'
import Branding from './branding.vue'
import JobList from './jobList.vue'

const basePath = '/msdchina'

const brandingRoute = {
  name: 'msdBrandingPage',
  path: `${basePath}/about`,
  component: Branding,
  meta: {
    pageType: COMPANY_PAGE_TYPE.BRANDING
  }
}

const landingRoute = {
  name: 'msdLandingPage',
  path: `${basePath}/careers`,
  component: Branding,
  meta: {
    pageType: COMPANY_PAGE_TYPE.LANDING
  }
}

const pcJobListRoute = {
  name: 'msdCompanyDetail',
  path: `${basePath}/professionals`,
  component: JobList,
  meta: {
    pageType: COMPANY_PAGE_TYPE.JOB_LIST,
    title: '默沙东社会招聘',
    customCompanyId: ROOT_COMPANY_ID.MSD
  }
}

const msdMobileJobListRouteMap = {
  [ROOT_COMPANY_ID.MSD]: {
    name: 'msdJobList',
    path: `${basePath}/jobs`,
    component: JobList,
    meta: {
      pageType: COMPANY_PAGE_TYPE.JOB_LIST,
      title: '默沙东社会招聘'
    }
  },
  [ROOT_COMPANY_ID.MSD_MAH]: {
    name: 'mahJobList',
    path: `${basePath}/professionals/mah`,
    component: JobList,
    meta: {
      pageType: COMPANY_PAGE_TYPE.JOB_LIST,
      title: '默沙东社会招聘',
      customCompanyId: ROOT_COMPANY_ID.MSD_MAH,
      defaultCustomFilterName: 'custom_filter_5541=16449'
    }
  },
  [ROOT_COMPANY_ID.MSD_MMD]: {
    name: 'mmdJobList',
    path: `${basePath}/professionals/mmd`,
    component: JobList,
    meta: {
      pageType: COMPANY_PAGE_TYPE.JOB_LIST,
      title: '默沙东社会招聘',
      customCompanyId: ROOT_COMPANY_ID.MSD_MMD,
      defaultCustomFilterName: 'custom_filter_5541=16447'
    }
  },
  [ROOT_COMPANY_ID.MSD_GHH]: {
    name: 'ghhJobList',
    path: `${basePath}/professionals/ghh`,
    component: JobList,
    meta: {
      pageType: COMPANY_PAGE_TYPE.JOB_LIST,
      title: '默沙东社会招聘',
      customCompanyId: ROOT_COMPANY_ID.MSD_GHH,
      defaultCustomFilterName: 'custom_filter_5541=16448'
    }
  },
  [ROOT_COMPANY_ID.MSD_GSF]: {
    name: 'gsfJobList',
    path: `${basePath}/professionals/gsf`,
    component: JobList,
    meta: {
      pageType: COMPANY_PAGE_TYPE.JOB_LIST,
      title: '默沙东社会招聘',
      customCompanyId: ROOT_COMPANY_ID.MSD_GSF,
      defaultCustomFilterName: 'custom_filter_5541=16450'
    }
  },
  [ROOT_COMPANY_ID.MSD_MRL]: {
    name: 'mrlJobList',
    path: `${basePath}/professionals/mrl`,
    component: JobList,
    meta: {
      pageType: COMPANY_PAGE_TYPE.JOB_LIST,
      title: '默沙东社会招聘',
      customCompanyId: ROOT_COMPANY_ID.MSD_MRL,
      defaultCustomFilterName: 'custom_filter_5541=16446'
    }
  }
}

const route = _.concat([brandingRoute, landingRoute], _.values(msdMobileJobListRouteMap), [pcJobListRoute])

export default route

export { brandingRoute, landingRoute, msdMobileJobListRouteMap }
